import { cn } from '@/lib/utils'

interface TrustBadgeProps {
  /** Icon to display (Lucide icon component) */
  icon: React.ReactNode
  /** Badge title */
  title: string
  /** Badge description */
  description?: string
  /** Additional classes */
  className?: string
}

export function TrustBadge({ icon, title, description, className }: TrustBadgeProps) {
  return (
    <div
      className={cn(
        'glass-subtle flex items-start gap-4 rounded-xl p-4 transition-all duration-300',
        'hover:bg-card/60',
        className
      )}
    >
      <div className="bg-primary/10 text-primary flex h-10 w-10 shrink-0 items-center justify-center rounded-lg">
        {icon}
      </div>
      <div>
        <h3 className="text-foreground font-semibold">{title}</h3>
        {description && <p className="text-muted-foreground mt-1 text-sm">{description}</p>}
      </div>
    </div>
  )
}

interface TrustBadgeGridProps {
  badges: Array<{
    icon: React.ReactNode
    title: string
    description?: string
  }>
  className?: string
}

export function TrustBadgeGrid({ badges, className }: TrustBadgeGridProps) {
  return (
    <div className={cn('grid gap-4 md:grid-cols-3', className)}>
      {badges.map((badge, index) => (
        <TrustBadge key={index} icon={badge.icon} title={badge.title} description={badge.description} />
      ))}
    </div>
  )
}
